import { FeatureDetail } from '@/shared/components/Subscription/SubscriptionTier'

export type TierUIDetail = {
  description: string
  features: FeatureDetail[] // Using the type from SubscriptionTier component
  isPopular?: boolean
  actionButtonText?: string
}

export const TIER_UI_DETAILS: Record<string, TierUIDetail> = {
  'Free': {
    description: 'Ideal for small fleets looking for essential route management tools and support to kickstart their operations.',
    features: [
      { title: 'Basic Route Planning', details: 'Efficiently resequence routes for your runs using travel time and distance.', available: 'yes' },
      { title: 'Email Support', details: 'Get assistance via email during standard business hours.', available: 'yes' },
      { title: 'Basic Reporting', details: 'Access fundamental reports on your fleet performance and key metrics.', available: 'yes' },
      { title: 'Compliance Tools', details: 'Planning Tools to help manage driver fatigue in accordance to industry regulations and safety standards.', available: 'yes' },
      { title: 'Driver Mobile App', details: 'Drivers can view routes and basic order info. (Runsheet publishing not included)', available: 'no' },
      { title: 'Up to 3 Runs', details: 'Manage and track a fleet of up to 3 runs simultaneously.', available: 'neutral' },
    ],
    isPopular: false,
    actionButtonText: 'Continue with Free',
  },
  'Premium': {
    description: 'For growing businesses needing advanced tools, priority support, and increased capacity for smooth scaling.',
    features: [
      { title: 'AI Route Optimization', details: 'Utilize sophisticated algorithms for complex routing scenarios, including time windows and capacities.', available: 'yes' },
      { title: 'Priority Support', details: 'Receive faster response times and priority assistance via email and chat.', available: 'yes' },
      { title: 'Advance Reporting and Analytics', details: 'Gain deeper insights with comprehensive analytics and customizable dashboards.', available: 'yes' },
      { title: 'Custom Integrations (Limited)', details: 'Connect with other business systems through available standard integrations.', available: 'yes' },
      { title: 'Driver Mobile App (Full Access)', details: 'Full-featured mobile app for drivers, including POD, real-time updates, and communication. Includes runsheet publishing.', available: 'yes' },
      { title: 'Unlimited Runs', details: 'Scale your operations with unlimited runs.', available: 'neutral' },
    ],
    isPopular: true,
    actionButtonText: 'Continue with Premium',
  },
  'Enterprise': {
    description: 'Comprehensive, tailored solutions for large-scale operations requiring custom integrations and dedicated support.',
    features: [
      { title: 'Enterprise Route Optimization', details: 'Tailored, high-performance optimization for extensive fleets with custom rule sets.', available: 'yes' },
      { title: 'Dedicated Support', details: '9-5 support with a dedicated account manager and SLAs.', available: 'yes' },
      { title: 'Custom Reporting & BI', details: 'Build and schedule fully custom reports and integrate with Business Intelligence tools.', available: 'yes' },
      { title: 'Full API Access', details: 'Complete API access for deep integration with your existing enterprise systems.', available: 'yes' },
      { title: 'Advanced Multi-Depot Management', details: 'Sophisticated tools for managing complex multi-depot logistics and inter-depot transfers.', available: 'yes' },
      { title: 'Unlimited Runs', details: 'Scale your operations with unlimited runs.', available: 'neutral' },
    ],
    isPopular: false,
    actionButtonText: 'Contact Sales',
  },
}


export const getTierUIDetails = (tierName: string | null): TierUIDetail | undefined => {
  if (!tierName) return undefined

  return TIER_UI_DETAILS[tierName]
}